// src/pages/TermsOfService.jsx

import React from 'react';
import { Container, Box, Typography, List, ListItem, ListItemText, Link } from '@mui/material';

export default function TermsOfService() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </Box>

      <Typography variant="body1" sx={{ mb: 2 }}>
        By using Meetin, you agree to these Terms and to comply with applicable laws and regulations, including those in the EU, US, and Israel as relevant. If you do not agree, please do not use the service.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Use of Service</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        You are responsible for your account and the content you provide. Do not misuse the service, interfere with its operation, or violate any law (including data protection and anti-spam laws).
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Accounts</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        You must provide accurate information and keep your account secure. You are responsible for activity under your credentials. We may suspend or terminate accounts that violate these terms or applicable law.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Subscriptions and Billing</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        If applicable, subscription fees are billed per your selected plan. Taxes may apply based on your location. Cancellation and proration terms are described at checkout or in your account.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Privacy</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Our <Link href="/privacy">Privacy Policy</Link> describes how we handle personal data and comply with applicable data protection laws.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Intellectual Property</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Meetin, including its trademarks, logos, and software, is protected by intellectual property rights. You may not copy, modify, or distribute any part without permission.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Disclaimers and Limitation of Liability</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Meetin is provided “as is” and “as available.” To the extent permitted by law, we disclaim warranties and limit liability for indirect, incidental, or consequential damages.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Changes</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        We may update these Terms. Material changes will be notified via the service or email. Continued use constitutes acceptance of changes.
      </Typography>
    </Container>
  );
}


